import React from "react";
import { Link } from "react-router-dom";
import { Reveal, Eyebrow, scrollToId } from "./MarketingUI";
import { PlayCircle, ArrowRight, ShieldCheck, Database } from "lucide-react";

// "See GovFlowState in Action" — bridges marketing to the interactive demo.
// Explore the Demo -> /login (no auto-auth). Request a Demo -> contact (higher-intent sales).
export default function SeeInAction() {
  return (
    <section className="relative overflow-hidden bg-brand-navy-900 py-24 sm:py-28" data-testid="see-in-action-section">
      <div className="absolute inset-0 opacity-40" style={{ background: "radial-gradient(900px 400px at 20% 0%, rgba(63,127,181,0.22), transparent 60%)" }} />
      <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "linear-gradient(#3F7FB5 1px, transparent 1px), linear-gradient(90deg, #3F7FB5 1px, transparent 1px)", backgroundSize: "56px 56px" }} />
      <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
        <Reveal><Eyebrow tone="gold">Experience the product</Eyebrow></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mx-auto mt-4 max-w-2xl font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl">
            See GovFlowState in action.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-white/65">
            Explore a working GovFlowState environment powered by real public legislative information and clearly identified demonstration workflows.
          </p>
        </Reveal>

        <Reveal delay={0.16}>
          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row" data-testid="see-in-action-ctas">
            <Link to="/login" className="group inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-bold text-brand-navy-900 shadow-[0_10px_30px_-8px_rgba(255,255,255,0.35)] transition-transform hover:-translate-y-0.5" data-testid="explore-demo-cta">
              <PlayCircle className="h-4 w-4" /> Explore the Demo
            </Link>
            <button onClick={() => scrollToId("contact")} className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/10" data-testid="see-in-action-request-demo">
              Request a Demo <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </Reveal>

        <Reveal delay={0.22}>
          <div className="mx-auto mt-8 flex max-w-xl flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-white/50">
            <span className="inline-flex items-center gap-1.5"><Database className="h-3.5 w-3.5 text-brand-civic-100" /> Real public legislative data</span>
            <span className="inline-flex items-center gap-1.5"><ShieldCheck className="h-3.5 w-3.5 text-brand-gold" /> Clearly labeled demonstration workflows</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
